import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { memo, useEffect, useState } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { isNull } from 'lodash';
import { setTourTripSearchParam, tourSearchRequest } from '../../../../store/slices/tripSearch';
import ErrorTooltip from '../../../ErrorTooltip';
import TourStartDateFilter from '../TourFilters/TourStartDateFilter';
import TourEndDateFilter from '../TourFilters/TourEndDateFilter';
import TourDestinationSearch from '../TourFilters/TourDestinationSearch';

const TourSearchBar = ({ tripId }) => {
  const dispatch = useDispatch();
  const reduxStore = useStore();
  const [doOpenTourStartDate, setDoOpenTourStartDate] = useState(false);
  const [doOpenTourEndDate, setDoOpenTourEndDate] = useState(false);
  const initialFormValidations = { startDate: null, endDate: null, destination: null };
  const [formValidations, setFormValidations] = useState(initialFormValidations);

  const handleOpenFirstDatePicker = (val) => {
    setDoOpenTourStartDate(val);
    if (!val) {
      setTimeout(() => {
        setDoOpenTourEndDate(true);
      }, 50);
    }
  };

  useEffect(() => {
    if (doOpenTourStartDate) setDoOpenTourEndDate(false);
  }, [doOpenTourStartDate]);

  const validateSearch = (obj, doShowValidationErrors = true) => {
    const validationObj = { ...initialFormValidations };
    let isValid = true;
    if (!obj) return false;
    if (obj.text) return true;
    if (!obj.startDate) {
      validationObj.checkInDate = 'A first date is required.';
      isValid = false;
    } else if (!obj.endDate) {
      validationObj.checkOutDate = 'A last date is required.';
      isValid = false;
    } else if (dayjs(obj.endDate).isBefore(dayjs(obj.startDate), 'day')) {
      validationObj.checkOutDate = 'The last date cannot be before the first one.';
      isValid = false;
    } else if (!obj.country) {
      validationObj.destination = 'Destination is required';
      isValid = false;
    }
    if (doShowValidationErrors) setFormValidations(validationObj);
    return isValid;
  };

  const handleSearch = (event, doShowValidationErrors = true) => {
    if (event) event.preventDefault();
    const submittedSearchInputs = reduxStore.getState().tripSearch.searchInputs;
    if (validateSearch(submittedSearchInputs.tour, doShowValidationErrors)) {
      dispatch(setTourTripSearchParam({ ...submittedSearchInputs.tour, page: 1 }));
      dispatch(tourSearchRequest({ isTripSearch: false, tripId }));
    }
  };

  const handleResetValidation = () => {
    setFormValidations(initialFormValidations);
  };

  return (
    <form onSubmit={handleSearch} onFocus={handleResetValidation}>
      <div className="mt-2 p-2 bord">
        <div className="flex gap-2 flex-wrap text-theme">
          <ErrorTooltip
            title={formValidations.destination || ''}
            open={!isNull(formValidations.destination)}
            arrow
          >
            <div className="xl:col-span-4 col-span-4">
              <TourDestinationSearch tripId={tripId} />
            </div>
          </ErrorTooltip>
          <ErrorTooltip
            title={formValidations.checkInDate || ''}
            open={!isNull(formValidations.checkInDate)}
            arrow
          >
            <div className="xl:col-span-2 col-span-3">
              <TourStartDateFilter
                doOpenDatePicker={doOpenTourStartDate}
                setDoOpenDatePicker={handleOpenFirstDatePicker}
                tripId={tripId}
              />
            </div>
          </ErrorTooltip>
          <ErrorTooltip
            title={formValidations.checkOutDate || ''}
            open={!isNull(formValidations.checkOutDate)}
            arrow
          >
            <div className="xl:col-span-2 col-span-3">
              <TourEndDateFilter
                doOpenDatePicker={doOpenTourEndDate}
                setDoOpenDatePicker={setDoOpenTourEndDate}
                tripId={tripId}
              />
            </div>
          </ErrorTooltip>
          <div>
            <button
              type="submit"
              className="px-8 min-h-12 h-auto bg-searchButton-0 text-white text-base font-bold h-full w-max rounded-2xl"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

TourSearchBar.propTypes = {
  tripId: PropTypes.string,
};

TourSearchBar.defaultProps = {
  tripId: undefined,
};

export default memo(TourSearchBar);
